/**
 * 
{{ 'tpt-showmore.css' | asset_url | stylesheet_tag }}
<script src="{{ 'tpt-showmore.js' | asset_url }}" defer="defer"></script>

<tpt-more-data class="description-container {{ section.settings.alignment }}" style="--data-max-height: 90px" data-max-height="90">
    <tpt-more-content class="collection-description">
        <tpt-more-element>
            DATA
        </tpt-more-element>
    </tpt-more-content>

    <tpt-more-container class="more-button">
        <tpt-more-button data-more-text="Show more" data-less-text="Show less" role="button" aria-label="Label"></tpt-more-button>
    </tpt-more-container>
</tpt-more-data>
*/

if (!customElements.get('tpt-more-button')) {
	customElements.define(
		'tpt-more-button',
		class TptShowMore extends HTMLElement {
			constructor() {
				super();

				const moreDataContainer = this.closest('tpt-more-data');
				const maxHeight = moreDataContainer.getAttribute('data-max-height');
				const dataHeight = moreDataContainer.querySelector('.tpt-more-element').offsetHeight;

				if (dataHeight > parseInt(maxHeight)) {
					moreDataContainer.classList.add('has-more-data');
				}

				this.addEventListener('click', this.toggleMore.bind(this));
				this.addEventListener('keypress', this.keyPress);
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.toggleMore();
				}
			}

			toggleMore() {
				this.classList.toggle('active');
				this.closest('tpt-more-data').classList.toggle('active');
			}
		}
	);
}
